import React from 'react';
import BasicCli from '../../main/components/basicCli/BasicCli';
import IntegrationSettings from './Integration';

const IntegrationPage: React.FC = () => {
  return (
    <BasicCli>
      <IntegrationSettings />
    </BasicCli>
  );
};

export default IntegrationPage;
